import { BuiltinMemberValue } from '../BuiltinMemberValue';
export class WellKnownSymbolBase extends BuiltinMemberValue {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitPushString(node, this.symbol);
            sb.emitHelper(node, options, sb.helpers.wrapSymbol);
        }
    }
}

//# sourceMappingURL=WellKnownSymbolBase.js.map
